module.exports = __webpack_public_path__ + "static/media/whatslogo.c7f684ca.png";